import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import { checklistsKeys } from '@core/react-query/features/checklists'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { IChecklist } from '@core/entities/checklist/Checklist'

export const getCreateChecklistDraftMutationOptions = (
  queryClient: QueryClient,
) => {
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return {
    ...checklistKeys.createDraft,
    onSuccess: (draft) => {
      updateInfiniteQueryItem(
        checklistsKeys.drafts({
          organisationId: draft.template.organisationId,
          projectIds: [draft.projectId],
          isUsedForInspections: draft.template.usedForInspections || undefined,
        }).queryKey,
        draft,
      )
    },
  }
}

export const useCreateChecklistDraft = () => {
  const queryClient = useQueryClient()
  return useMutation<IChecklist, RequestErrorType, RequestTypes['createDraft']>(
    getCreateChecklistDraftMutationOptions(queryClient),
  )
}
